import { ThumbType } from '~/shared/api'
import { GalleryImage } from './type'

export const mapPhotoToImage = (photo: ThumbType): GalleryImage => ({
  id: photo.uuid,
  src: photo.originalUrlDownload,
  preview: photo.previewUrlDownload,
})
